import { render, staticRenderFns } from "./RetentionRuleViewModal.vue?vue&type=template&id=5c38a256&"
import script from "./RetentionRuleViewModal.vue?vue&type=script&lang=js&"
export * from "./RetentionRuleViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports